import { Text, Stack, RadioGroup } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../../shared/stores/RootStore";
import { useEffect } from "react";
import { MapMode } from "../../../../survey/stores/MapStore";
import { ImportHlaBBoxControls } from "./ImportHlaBBoxControls";
import { ImportHlaAtoBControls } from "./ImportHlaAtoBControls";

const MapQueryControlsBase: React.FC = () => {
  const { mapStore } = useStores();

  useEffect(() => {
    if (mapStore.mode === MapMode.ImportHlaAtoB) {
    }
  }, [mapStore.mode]);

  return (
    <Stack py={4} px={4} w={320} flexShrink={0} gap={4}>
      <Text fontWeight={"semibold"}>Start high-level assessment</Text>

      <RadioGroup.Root
        colorPalette="primary"
        value={mapStore.mode}
        onValueChange={({ value }) => {
          mapStore.setMode(value as MapMode);
        }}
      >
        <RadioGroup.Item value={MapMode.ImportHlaBBox}>
          <RadioGroup.ItemHiddenInput />
          <RadioGroup.ItemIndicator />
          <RadioGroup.ItemText>Select area</RadioGroup.ItemText>
        </RadioGroup.Item>
        <RadioGroup.Item value={MapMode.ImportHlaAtoB}>
          <RadioGroup.ItemHiddenInput />
          <RadioGroup.ItemIndicator />
          <RadioGroup.ItemText>
            Select origin and destination
          </RadioGroup.ItemText>
        </RadioGroup.Item>
      </RadioGroup.Root>

      {mapStore.mode === MapMode.ImportHlaBBox ? (
        <ImportHlaBBoxControls />
      ) : (
        <ImportHlaAtoBControls />
      )}
    </Stack>
  );
};

export const MapQueryControls = observer(MapQueryControlsBase);
